module.exports = require("./ne-NP");